export default "__VITE_ASSET__CGmeEGRk__"